import React from "react";

import { BlockWrapper, IntroBlock } from "components/Block";

import { Inner, Image } from "./styles";

const Investors = ({ content, ...props }) => {
  return (
    <BlockWrapper mb="-70px" shade="light" zIndex="2">
      <IntroBlock content={content} />
      <Inner>
        {content.items.map((investor, index) => (
          <a
            key={index}
            href={investor.path}
            target="_blank"
            rel="noopener noreferrer"
          >
            <Image
              alt={investor.name}
              src={investor.image.childImageSharp.fluid.src}
            />
          </a>
        ))}
      </Inner>
    </BlockWrapper>
  );
};

export default Investors;
